import VueTypes, { nullable } from 'vue-types'

// MODEL: ServiceItem
export const ServiceItem = VueTypes.shape({
    id: VueTypes.number.isRequired,
    name: VueTypes.string.isRequired,
    is_switch: VueTypes.bool.isRequired,
    description: VueTypes.oneOfType([String, nullable]).isRequired,
    active: VueTypes.bool.def(false),
}).isRequired

export const createServiceItem = ({
    name, id, is_switch, active, description
}) => {
    return {
        id: id,
        is_switch: is_switch,
        name: name,
        description: description,
        active: active,
    }
}